import { render, staticRenderFns } from "./WizardForm.vue?vue&type=template&id=7130f114"
import script from "./WizardForm.vue?vue&type=script&lang=js"
export * from "./WizardForm.vue?vue&type=script&lang=js"
import style0 from "./WizardForm.vue?vue&type=style&index=0&id=7130f114&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports